export class User {
  constructor({
    id,
    email,
    firstName,
    lastName,
    phoneNumber,
    countryCode,
    createdAt,
    updatedAt,
    metadata
  } = {}) {
    this.id = id;
    this.email = email;
    this.firstName = firstName;
    this.lastName = lastName;
    this.phoneNumber = phoneNumber;
    this.countryCode = countryCode;
    this.createdAt = createdAt;
    this.updatedAt = updatedAt;
    this.metadata = metadata;

    Object.freeze(this); // immutable
  }
}
